import Dropzone from 'react-dropzone'

import { ICardContractUpload } from './types'
import css from './ui.module.scss'

import imgEmty from '@img/empty.svg'
import { IconClearClose } from '@img/icons'

import { Empty, Flex, Modal, Loader, Button, Table, Container } from '@ui/index'


/** Окно загрузки файлов по договору */
export const CardContractUpload = ({
    isOpen, isLoading, sectionList, selectedSectionID, 
    handlerButtonCancel, thisFileUploader
}: ICardContractUpload) => {
    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handlerButtonCancel} overflowY="hidden" maxWidth="330px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>Загрузка файлов</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container>
                    <Dropzone onDropAccepted={(files) => thisFileUploader(files)} multiple={true}>
                        {({ getRootProps, getInputProps, isDragAccept, isDragActive }) => (
                            <div {...getRootProps({ className: isDragAccept ? `dropZone_container dropZone_dragAccept` : `dropZone_container`, onClick: event => event.stopPropagation() })}>
                                <input {...getInputProps()} />

                                <Flex gap='6px' className='modal_container-content' width='100%'>
                                    <Loader isOpen={isLoading} backdrop title='Загрузка...' />

                                    <div className={`${css['hint_card']} ${isDragActive ? css['hint_card__drag_active'] : ''}`}>
                                        <p className={css['hint_title']}>
                                            {isDragActive ? 'Отпустите файлы для загрузки' : 'Как загрузить файлы'}
                                        </p>

                                        <div className={css['hint_steps']}>
                                            <div className={css['hint_step']}>
                                                <span className={css['hint_step_number']}>1</span>
                                                <span className={css['hint_step_text']}>Выберите раздел из списка</span>
                                            </div>

                                            <div className={css['hint_step']}>
                                                <span className={css['hint_step_number']}>2</span>
                                                <span className={css['hint_step_text']}>Перетащите файлы в это окно или выберите их из каталога</span>
                                            </div>
                                        </div>
                                    </div>

                                    <Table.Content gap='4px' isScrollVertical={false} minHeight='160px'>
                                        {!sectionList.value
                                            ? <Empty image={imgEmty} title="Секции отсутствуют" />
                                            : sectionList.value.map((item, index) => (
                                                <Table.RowCheckBox key={index + 1} header={index + 1} headerWidth="40px"
                                                    isSelected={selectedSectionID.value === item.contractSectionID}
                                                    onClick={() => selectedSectionID.setValue(item.contractSectionID)}>

                                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                        <p>{item.contractSectionName}</p>
                                                    </div>
                                                </Table.RowCheckBox>
                                            ))
                                        }
                                    </Table.Content>
                                </Flex>                                
                            </div>
                        )}
                    </Dropzone>

                    <Dropzone onDropAccepted={(files) => thisFileUploader(files)}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <Button width='100%'>Выбрать из каталога</Button>
                            </div>
                        )}
                    </Dropzone>
                </Container>
            </Flex>
        </Modal>
    </>
}